import {getUrlParams} from 'utils/urlParams'
import {buildWidgetConfig, WidgetConfig} from 'widgets/helpers/widgetConfig'
import {
  handleError,
  initCustomErrorListener,
  WidgetNamesForErrorLogs
} from 'widgets/helpers/widgetErrorHandlers'

import {renderWidget} from './renderWidget'

export const initWidget = <
  WidgetType extends (props: WidgetConfig) => JSX.Element
>(
  Widget: WidgetType,
  errorLogsName: WidgetNamesForErrorLogs
) => {
  initCustomErrorListener(errorLogsName)

  try {
    const urlParams = getUrlParams()

    buildWidgetConfig(urlParams)
      .then(initConfig => {
        renderWidget<WidgetConfig>(Widget, initConfig)
      })
      .catch(error => handleError(error, errorLogsName))
  } catch (error) {
    handleError(error, errorLogsName)
  }
}
